export function getCurrentDateInThaiFormat() {
  const now = new Date();

  // ตั้งค่าให้แสดงวันที่เป็นโซนเวลาไทย (Asia/Bangkok)
  const options = {
    timeZone: "Asia/Bangkok",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };

  // ใช้ toLocaleDateString เพื่อแปลงเป็นวันที่ตามโซนเวลาไทย
  const dateThai = now.toLocaleDateString("en-GB", options);

  // แปลงรูปแบบให้เป็น YYYY-MM-DD (จาก DD/MM/YYYY ที่ได้จาก en-GB)
  const [day, month, year] = dateThai.split("/");
  return `${year}-${month}-${day}`;
}
